import React from "react";
import companyLogo from "../assets/images/logo/whiteLogo.png";
const Footer = () => {
  return (
    <div
      className={`footer tw-relative tw-start-0 tw-end-0 tw-z-10 -tw-bottom-1 tw-bg-secondary tw-flex tw-items-center tw-justify-center`}
    >
      <div className="tw-text-white tw-flex md:tw-gap-1 tw-flex-col md:tw-flex-row tw-text-center">
        <p>Developed and designed by</p>
        <p>Innovadigit Solutions App </p>
      </div>
      <img
        className="tw-absolute tw-end-12"
        src={companyLogo}
        alt="Innovadigit Solutions"
        width="80px"
      />
    </div>
  );
};

export default Footer;
